export enum AuthFallbackRoutes {
  INDEX = '/',
  LOGIN = '/login',
}
